import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {UserCarePlanItemDgSearchResults} from "../models/datagrid-search-results/user-care-plan-item.dg-search-results.model";
import {UserCarePlanItemService} from "../providers/user-care-plan-item.service";

@Injectable()
export class UserCarePlanItemsDetailsResolve implements Resolve<UserCarePlanItemDgSearchResults> {
  constructor(private userCarePlanItemService: UserCarePlanItemService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<UserCarePlanItemDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    let queryParam = route.queryParams['uuid'];
    if (queryParam !== undefined) {
      let map = new Map<string, string>();
      map.set("userCarePlanUUID", queryParam);
      return this.userCarePlanItemService.searchForResults(environment.DEFAULT_RESULTS_LIMIT, 0, map, 'ASC', 'itemStartDate').pipe(tap(res => {
        this.appStateService.updateIsBusySubject(false);
      }));
    } else {
      return this.userCarePlanItemService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'itemStartDate').pipe(tap(res => {
        this.appStateService.updateIsBusySubject(false);
      }));
    }
  }
}
